<script src="https://apis.google.com/js/platform.js"></script>

<mat-toolbar>
  <span [hidden]="userForm.value.id"> Add Toolkit Admin User</span>
  <span [hidden]="!userForm.value.id"> Edit Toolkit Admin User</span>
  <span class="spacer"></span>
  <div style="float:right; position: fixed; bottom: 50px; right: 2%; z-index: 100; display: flex; flex-direction: column-reverse; align-items: center;">
    <button mat-fab color="primary" aria-label="Cancel" (click)="onCancel()">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div style="padding: 20px; width: 355px;">

  <ngx-spinner [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
    <p class="loading" style="color: white; font-weight: bold;">Saving User ...</p>
  </ngx-spinner>

  <form [formGroup]="userForm">

    <mat-form-field>
      <input matInput
             placeholder="Name"
             formControlName="name">
    </mat-form-field>

    <mat-form-field [hidden]="emailAddress">
      <input matInput
             placeholder="Email Address"
             formControlName="emailAddress">
    </mat-form-field>

    <div [hidden]="!emailAddress" style="padding-bottom:10px;">
      <span style="display: flex; align-items: start;" style="margin-top: 15px; font-weight: bold;"><span style="font-weight: normal;">Email Address:  </span><span style="background-color: lightgray;">{{userForm.controls['emailAddress'].value}}</span></span>
    </div>

    <mat-form-field [hidden]="(this.globalStateQuery.getSelectedEnvironment() === 'staging' || this.globalStateQuery.getSelectedEnvironment() === 'production')">
      <input matInput
             placeholder="Env Prefix"
             formControlName="envPrefix">
    </mat-form-field>

    <mat-form-field style="width: 75px;" [hidden]="!this.globalStateQuery.getCachedUser() || (this.globalStateQuery.getCachedUser() && this.globalStateQuery.getCachedUser().role !== 'admin')">
      <mat-label>Role</mat-label>
      <mat-select style="width: 75px;" formControlName="role">
        <mat-option value="admin">Admin</mat-option>
        <mat-option value="user">User</mat-option>
      </mat-select>
    </mat-form-field >

    <div [hidden]="!this.globalStateQuery.getCachedUser() || (this.globalStateQuery.getCachedUser() && this.globalStateQuery.getCachedUser().role == 'admin')" style="padding-bottom:10px;">
      <span style="display: flex; align-items: start;" style="margin-top: 15px; font-weight: bold;"><span style="font-weight: normal;">Role:  </span><span style="background-color: lightgray;">{{userForm.controls['role'].value}}</span></span>
    </div>

    <div style="padding-bottom:10px;">
      <span style="display: flex; align-items: start;" style="margin-top: 15px; font-weight: bold;"><span style="font-weight: normal;">Federated Username:  </span><span style="background-color: lightgray;">{{userForm.controls['username'].value ?? '-- Awaiting 1st Login --'}}</span></span>
    </div>

    <div style="height: 10px"></div>

  </form>

  <div style="text-align: left; margin: auto">
      <button type="button" mat-flat-button (click)="upsertUser()" [disabled]="!userForm.valid" style="margin-right: 10px;">Save</button>
      <button type="button" mat-stroked-button (click)="onCancel()">Cancel</button>
  </div>

</div>





